var map = {
	"./Architectural-cladding/1.jpg": 1901,
	"./Architectural-cladding/2.PNG": 6785,
	"./Architectural-cladding/3.PNG": 4265,
	"./Material-bin-shed/757downerAshphltplat(1).png": 2613,
	"./Material-bin-shed/757downerAshphltplat(2).png": 268,
	"./Material-bin-shed/757downerAshphltplat(3).png": 729,
	"./Precast-lift-shaft/1.PNG": 715,
	"./Precast-lift-shaft/3.PNG": 1559,
	"./Precast-lift-shaft/4.PNG": 3925,
	"./Precast-lift-shaft/LiftPanels(5).PNG": 9660,
	"./Precast-lift-shaft/LiftPanels(7).PNG": 2457,
	"./Precast-lift-shaft/LiftPanels(9).PNG": 3496,
	"./Service-stations/10.PNG": 4759,
	"./Service-stations/13.PNG": 7932,
	"./Service-stations/14.PNG": 4369,
	"./Structural-steel-precast-panel/401.png": 4786,
	"./Structural-steel-precast-panel/480.png": 5272,
	"./Structural-steel-precast-panel/494.png": 1951,
	"./steel-sheet-cladding/1105-PROTOTYPE-SHED(3).png": 3568,
	"./steel-sheet-cladding/sheet-cladding-1.jpg": 5874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8283;